import { getModules } from "../../../../../actions/Utilities/Common";
import { useQuery } from "react-query";

export default function useGetModules() {
  const { data } = useQuery("Modules", getModules, {
    refetchOnWindowFocus: false,
  });
  return data;
}
